import { render, staticRenderFns } from "./AMCTeacherCourseDetail.vue?vue&type=template&id=9468a27e&scoped=true"
import script from "./AMCTeacherCourseDetail.vue?vue&type=script&lang=js"
export * from "./AMCTeacherCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./AMCTeacherCourseDetail.vue?vue&type=style&index=0&id=9468a27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9468a27e",
  null
  
)

export default component.exports